import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { ShieldCheck, X } from 'lucide-react';

export const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasAccepted = localStorage.getItem('cookies-accepted');
    if (!hasAccepted) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookies-accepted', 'true');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-8 md:max-w-md z-[100]"
          role="region"
          aria-label="Aviso de cookies"
        >
          <div className="bg-brand-dark-blue text-brand-white p-5 md:p-6 rounded-[1.5rem] md:rounded-[2rem] shadow-2xl border border-brand-white/10 backdrop-blur-xl bg-opacity-95">
            <div className="flex items-start gap-3 md:gap-4">
              <div className="bg-brand-green/20 p-2 md:p-3 rounded-xl md:rounded-2xl text-brand-green shrink-0" aria-hidden="true">
                <ShieldCheck size={20} className="md:w-6 md:h-6" />
              </div>
              <div className="space-y-3 md:space-y-4">
                <div>
                  <h4 className="font-bold text-base md:text-lg leading-tight">Privacidad</h4>
                  <p className="text-[11px] md:text-sm text-brand-white/70 mt-1 leading-relaxed">
                    Usamos cookies para mejorar su experiencia. Al navegar, acepta nuestras políticas.
                  </p>
                </div>
                <div className="flex items-center gap-3 md:gap-4">
                  <button
                    onClick={handleAccept}
                    className="bg-brand-green text-brand-dark-blue px-4 md:px-6 py-2 md:py-2.5 rounded-lg md:rounded-xl font-bold text-xs md:text-sm hover:scale-105 transition-transform active:scale-95"
                    aria-label="Aceptar todas las cookies"
                  >
                    Aceptar
                  </button>
                  <button
                    onClick={() => setIsVisible(false)}
                    className="text-brand-white/50 hover:text-brand-white text-[10px] md:text-sm font-medium transition-colors"
                    aria-label="Configurar preferencias de cookies"
                  >
                    Configurar
                  </button>
                </div>
              </div>
              <button 
                onClick={() => setIsVisible(false)}
                className="text-brand-white/30 hover:text-brand-white transition-colors shrink-0"
                aria-label="Cerrar aviso de cookies"
              >
                <X size={18} aria-hidden="true" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
